import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Optional: Initialize modal if needed, though Bootstrap 4 usually handles data-toggle="modal" automatically.
    // We might need to store the modal instance if we were using Bootstrap 5 vanilla JS, 
    // but for Bootstrap 4 + jQuery, we just use the jQuery plugin.
  }

  open(event) {
    event.preventDefault()
    $(this.element).modal('show')
  }

  close(event) {
    event.preventDefault()
    $(this.element).modal('hide')
  }
}

